import { Button, Group, Box, useMantineTheme, Grid } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import {
  CustomReportInput,
  InputMaybe,
  Scalars,
  useGetLocationsQuery,
} from "src/generated/graphql";
import { memo } from "react";
import { object, date, array } from "yup";
import DatePicker from "src/components/DatePicker";
import MultiSelect from "src/components/MultiSelect";
import TimeInput from "src/components/TimeInput";
import { createDateTime } from "src/utils/dateHelper";

type GetDetailInfoProps = {
  handleSubmit: (date: CustomReportInput) => void;
};
export type IFormReport = CustomReportInput & {
  startAt: InputMaybe<Scalars["DateTime"]> | undefined;
  endAt: InputMaybe<Scalars["DateTime"]> | undefined;
  startTime: InputMaybe<Scalars["DateTime"]> | undefined;
  endTime: InputMaybe<Scalars["DateTime"]> | undefined;
};
export const initialReportValues = {
  locations: [],
  startAt: undefined,
  endAt: undefined,
  startTime: undefined,
  endTime: undefined,
};

const GetDetailInfo = ({ handleSubmit }: GetDetailInfoProps) => {
  const theme = useMantineTheme();
  const { data } = useGetLocationsQuery();

  const form = useForm<IFormReport>({
    initialValues: initialReportValues,
    validate: yupResolver(
      object().shape({
        locations: array()
          .min(1, "at least 1 Location is required")
          .required("Locations is required"),
        startAt: date().required("Required"),
        endAt: date().required("Required"),
        startTime: date().required("Start Time is required"),
        endTime: date().required("End Time is required"),
      })
    ),
  });

  const onSubmit = async (values: IFormReport) => {
    let _start = createDateTime(values.startAt, values.startTime);
    let _end = createDateTime(values.endAt, values.endTime);
    handleSubmit({
      locations: values.locations,
      startAt: _start,
      endAt: _end,
    });
  };

  return (
    <Box sx={{ maxWidth: 360 }} mx="auto">
      <form
        onSubmit={form.onSubmit((values) => {
          onSubmit(values);
        })}
      >
        <MultiSelect
          mt={0}
          data={
            data?.locationMany?.map((val) => ({
              value: val.id,
              label: val.name,
            })) || []
          }
          label="Select Locations"
          {...form.getInputProps("locations")}
        />

        <Grid justify="space-between">
          <Grid.Col span={6}>
            <DatePicker
              label="Expiry Start"
              maw={400}
              mx="auto"
              {...form.getInputProps("startAt")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TimeInput
              withSeconds
              label="Start Time"
              {...form.getInputProps("startTime")}
            />
          </Grid.Col>
        </Grid>

        <Grid justify="space-between">
          <Grid.Col span={6}>
            <DatePicker
              label="Expiry End"
              maw={400}
              mx="auto"
              {...form.getInputProps("endAt")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TimeInput
              withSeconds
              label="End Time"
              {...form.getInputProps("endTime")}
            />
          </Grid.Col>
        </Grid>
        <Group position="apart" mt="md">
          <Button
            radius="md"
            type="submit"
            style={{
              flex: 1,
            }}
            sx={{
              color: theme.colors.primaryTextColor[6],
              "&:hover": {
                backgroundColor: theme.colors.primary[4],
              },
            }}
          >
            Submit
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export default memo(GetDetailInfo);
